import React from 'react';
import Skeleton from 'react-loading-skeleton';
import '../../pages/Feed/styles.scss';

const SkeletonCard = () => {
  return (
    <div className="feed-container">
      <div>
        <div className="filters-container">
          <div className="filterContainer">
            <div className="filterByContainer">
              <p><Skeleton /> </p>
            </div>
            <div className="filterOptionContainer">
              <Skeleton />
            </div>
          </div>
        </div>
        <div className="profiles-container">
          <div className="profile-container">
            <div className="profile-img-container">
              <Skeleton
                height="30vw"
                style={{
                  display: 'block',
                }}
              />
            </div>
            <div className="profile-description-container">
              <Skeleton />
              <div className="profile-line-1">
                <h2 className="profile-header">
                  <Skeleton />
                </h2>
              </div>
              <h2 className="profile-subheader">
                <Skeleton />
              </h2>
              <p>
                <Skeleton />
              </p>
            </div>
          </div>
          <div className="profile-container">
            <div className="profile-img-container">
              <Skeleton
                height="30vw"
                style={{
                  display: 'block',
                }}
              />
            </div>
            <div className="profile-description-container">
              <Skeleton />
              <div className="profile-line-1">
                <h2 className="profile-header">
                  <Skeleton />
                </h2>
              </div>
              <h2 className="profile-subheader">
                <Skeleton />
              </h2>
              <p>
                <Skeleton />
              </p>
            </div>
          </div>
          <div className="profile-container">
            <div className="profile-img-container">
              <Skeleton
                height="30vw"
                style={{
                  display: 'block',
                }}
              />
            </div>
            <div className="profile-description-container">
              <Skeleton />
              <div className="profile-line-1">
                <h2 className="profile-header">
                  <Skeleton />
                </h2>
              </div>
              <h2 className="profile-subheader">
                <Skeleton />
              </h2>
              <p>
                <Skeleton />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard-container">
        <div className="personal-profile-img">
          <Skeleton circle height="15vw" width="15vw" />
        </div>
        <h2 className="profile-header center-text"><Skeleton /></h2>
        <h2 className="profile-subheader center-text"><Skeleton /></h2>
        <div className="summary-stats-container">
          <div className="summary-stat-box">
            <h1><Skeleton /></h1>
            <p><Skeleton /></p>
          </div>
          <div className="summary-stat-box">
            <h1><Skeleton /></h1>
            <p><Skeleton /></p>
          </div>
          <div className="summary-stat-box">
            <h1><Skeleton /></h1>
            <p><Skeleton /></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
